import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/Table/CustomTable";
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../ReduxStore/Slices/headerSlice";
import BannerinputGetModal from "../../ContentManagement/CommonModal/BannerModal/BannerinputGetModal";
import SchemeCreateModal from "../Modal/SchemeCreateModal";
import actions from "../../../ReduxStore/actions";
import { format } from "date-fns";
import SchemeApprovalApproved from "../../Management/SchemeApproval/GoldStakeSchemeApproval/SchemeApprovalApproved";
import PurchaseApprovalModalView from "../../Management/SchemeApproval/GoldStakeSchemeApproval/Modal/ShemeApprovalModalView";
import { toast } from "react-toastify";
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModal';

const GoldStakeSheme = () => {
  const dispatch = useDispatch();
  const tableData = [
    {
      title: "Scheme 1",
      Value: "$1000",
      Stake: "13.8g",
      Maturity: "24 Months",
      LockIn: "24 Months",
      Closure: "15/Mar/2025",
      documents: "banner.jpg",
      Status: "Pending",
    },
    {
      title: "Scheme 2",
      Value: "$1000",
      Stake: "13.8g",
      Maturity: "24 Months",
      LockIn: "24 Months",
      Closure: "15/Mar/2025",
      documents: "banner.jpg",
      Status: "Pending",
    },
  ];

  const role = sessionStorage.getItem("role")
  
  const tableHeadData = role==="superAdmin" ? [
    "S.No",
    "Title",
    // "Plan Id",
    "Value",
    "Stake",
    "Maturity",
    "Lock In",
    "Closure date",
    "Reap(%)",  
    "Reap months",
    "Creator Role",
    "Creator Name",
    "Status",
  ]:[
    "S.No",
    "Title",
    // "Plan Id",
    "Value",
    "Stake",
    "Maturity",
    "Lock In",
    "Closure date",
    "Reap(%)",  
    "Reap months",
    "Status",
  ]



  useEffect(() => {
    // setHeaderTitleName("User Registration")
    dispatch(setHeaderName("Scheme Management"));

    dispatch(setSubHeaderName("Gold Stake Schemes"));
  }, []);

  // const dispatch = useDispatch();
  const { getAllPlansGet } = useSelector((state) => state?.getAllPlansGet);
  const { updatePlanPut } = useSelector((state) => state?.updatePlanPut);


  console.log(getAllPlansGet, "getAllPlansGetgetAllPlansGetgetAllPlansGet");

  const { addPlanPost } = useSelector((state) => state?.addPlanPost);


  const { deletePlan } = useSelector(
    (state) => state?.deletePlan
  );

  const { addPlanWithApproval } = useSelector((state) => state?.addPlanWithApproval);
  const { updatePlanForReApproval } = useSelector((state) => state?.updatePlanForReApproval);


  const { getAllPlansBasedOnCreator } = useSelector((state) => state?.getAllPlansBasedOnCreator);
  const { getAllPlansWithCreator } = useSelector((state) => state?.getAllPlansWithCreator);


  const handleTableDataDelete = async (id) => {
    const data1 = {
      data: {},
      method: "delete",
      apiName: `deletePlan/${id}`,
    };

    const responseData = await dispatch(actions.DELETEPLAN(data1));
    if (responseData?.payload?.message === "Plan soft deleted successfully.") {
      toast.success("Plan soft deleted successfully.")
    } else {
      toast.error(responseData?.payload?.message)

    }
  }

  const [responseTableData, setResponseTableData] = useState([])
  console.log(responseTableData,"responseTableDataresponseTableData")

  useEffect(() => {
    if (role === "superAdmin") {
      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: "getAllPlansWithCreator",
        };

        const responseData = await dispatch(actions.GETALLPLANSWITHCREATOR(data1));
        if (responseData?.payload?.message === "Plans retrieved successfully.") {
          console.log(responseData?.payload?.message, "fdkkdfkdjfkdjfkd")
          setResponseTableData(responseData?.payload)
        }
      }
      fetchData()


    } else {
      const fetchData = async () => {

        const data1 = {
          data: {},
          method: "get",
          apiName: "getAllPlansBasedOnCreator",
        };

        // dispatch(actions.GETALLPLANSBASEDONCREATOR(data1));
        const responseData = await dispatch(actions.GETALLPLANSBASEDONCREATOR(data1));
        if (responseData?.payload?.message === "Plans retrieved successfully.") {
          console.log(responseData?.payload, "fdkkdfkdjfkdjfkd")


          setResponseTableData(responseData?.payload)
        }
      }
      fetchData()
    }

  }, [dispatch, updatePlanPut, addPlanPost, deletePlan, addPlanWithApproval, updatePlanForReApproval]);

  // const permissions= sessionStorage.getItem("permissions")
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  console.log(permissions?.Dashboard, "permisstions")

  console.log(permissions?.SchemeManagement?.["Gold Stake Schemes"]?.edit, "edittttt")

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      CustomerId: "--",
      Email: "--",
      MobileNumber: "--",
      UserType: "--",
      Status: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];

    if (role === "superAdmin") {
      responseTableData?.data?.map((data, index) => {
        return tempArr.push({
          title: data?.title,
          plan_id: data?.plan_id,
          value_of_purchase: `${data?.value_of_purchase} USD`,
          purchase_stake: `${data?.purchase_stake} g`,
          maturity_in_months: `${data?.maturity_in_months} Months`,
          lock_in_months: `${data?.lock_in_months} Months`,

          closure_date: format(new Date(data?.closure_date), "MMMM d, yyyy"),
          reap_percentage: `${data?.reap_percentage} %`,
          reap_months: `${data?.reap_months} Months`,
          creatorRole: data?.creatorRole?.roleName,
          creator: data?.creator?.name,


          status: data?.approval_status
            ? data?.approval_status.charAt(0).toUpperCase() + data?.approval_status.slice(1)
            : "--"

        });
      });
      setRowTableData(tempArr);
    } else {
      responseTableData?.data?.map((data, index) => {
        return tempArr.push({
          title: data?.title,
          plan_id: data?.plan_id,
          value_of_purchase: `${data?.value_of_purchase} USD`,
          purchase_stake: `${data?.purchase_stake} g`,
          maturity_in_months: `${data?.maturity_in_months} Months`,
          lock_in_months: `${data?.lock_in_months} Months`,

          closure_date: format(new Date(data?.closure_date), "MMMM d, yyyy"),
          reap_percentage: `${data?.reap_percentage} %`,
          reap_months: `${data?.reap_months} Months`,
          
          status: data?.approval_status
            ? data?.approval_status.charAt(0).toUpperCase() + data?.approval_status.slice(1)
            : "--"

        });
      });
      setRowTableData(tempArr);

    }
  }, [dispatch,responseTableData, getAllPlansGet, getAllPlansBasedOnCreator, getAllPlansWithCreator, updatePlanForReApproval, updatePlanPut, addPlanPost, deletePlan]);


  const editData = {
    title: "Gold Investment Plan",
    primary_button_text: "Invest Now",
    secondary_button_text: "Learn More",
    lock_in_months: "12",
    maturity_in_months: "24",
    currency: "USD",
    status: "active",
    closure_date: "2025-12-31",
    description: "A great investment opportunity in gold.",
    reap_percentage: "5",
    reap_months: "6",
    value_of_purchase: "1000",
    purchase_stake: "50",
    image_url: "https://example.com/gold-plan-image.jpg",
  };


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"
          tableView="tableView"
          tableData={rowTableData}
          title="Schemes"
          editData={editData}
          tableHeadData={tableHeadData}
          editModalName={SchemeCreateModal}
          // modalViewHeadingName="User Detail"
          modalName={SchemeCreateModal}
          tableEdit={permissions?.SchemeManagement?.["Gold Stake Schemes"]?.edit}
          dataCreate={permissions?.SchemeManagement?.["Gold Stake Schemes"]?.add}
          tableDelete={permissions?.SchemeManagement?.["Gold Stake Schemes"]?.delete}

          // dataCreate={true}




          modalVeiwName={PurchaseApprovalModalView}
          //   notModalTable="notModalTable"
          //   tableEdit="tableEdit"
          // tableView="tableView"
          modalViewHeadingName="Scheme Details"
          handleTableDataDelete={handleTableDataDelete}
        />
      </Grid>
    </Grid>
  );
};

export default GoldStakeSheme;
